<template>
  <AnimatePresence :mode="mode">
    <slot />
  </AnimatePresence>
</template>

<script>
import { AnimatePresence } from 'motion-v'

export default {
  name: 'ClAnimatePresence',
  components: { AnimatePresence },
  props: {
    mode: { type: String, default: 'wait' }
  }
}
</script>
